<template>
    <div class="knowledge-detail-box" ref="scrollboxWrapper" :class="{'box-overflow-hidden':callQuitWarning || callCommentInput}" >
        <div class="knowledge-detail-wrapper" ref="scrollBox" v-if="ajaxDone">
            <div class="knowledge-detail">
                <div class="knowledge-head">
                    <div class="k-type">知识点</div>
                    <div class="k-title">{{ knowledgeInfo.Title }}</div>
                </div>
                <div class="knowledge-content padding-sets">
                    <div class="k-author flexBox">
                        <img class="avator" :src="'' + knowledgeInfo.HeadPic" @error="$imgErr">
                        <div class="flexItem">
                            <p class="k-author-name" v-text="(knowledgeInfo.OwnerEngName || ' ') + ' ' + (knowledgeInfo.OwnerName || '')"></p>
                            <span class="k-update-last">更新于{{ knowledgeInfo.UpdatedOn | timeAgo }}</span>
                        </div>
                        <a class="k-enterprise-wechat">
                            <img class="tel" src="/static/images/call-qywx.png" @click="actionEnterpriseChat(knowledgeInfo.Title, knowledgeInfo.OwnerEngName + ' ' + knowledgeInfo.OwnerName, knowledgeInfo.ChatList)">
                            <transition name="opacity-fade">
                                <div class="tooltip-wrap" @click="setTooltipRead" v-if="tooltipShow">
                                    <span class="tooltip">我是知识负责人，可以找我私聊<i class="k-close">&#10005;</i></span>
                                    <span class="bottom-trangle"></span>
                                </div>
                            </transition>
                        </a>
                    </div>
                    
                    <div class="k-maintain" :class="[$style['k-maintain'], {[$style['k-maintain-font-reset']]: resetClass}]" ref="kMaintain" v-html="knowledgeInfo.PlainText"></div>

                    <!-- <div class="k-source flexBox" ref="ksource" v-if="sourceList.length">
                        <picture class="picture" v-for="(img, index) in sourceList" @click="showImg(index,img)">
                            <img class="img-loaded source-img" v-show="index < 4" :src="img.ThumbUrl">
                            <img class="img-loaded-detect" :src="img.ThumbUrl" v-show="false" @load="$placeImg">
                            <template v-if="sourceList.length > 4 && index === 3">
                                <div class="barrage" v-if="sourceList.length > 4 && index === 3"></div>
                                <div class="barrage-text">
                                    <span class="barrage-text-plus">+</span>{{ sourceList.length - 4 }}
                                </div>
                            </template> 
                        </picture>
                    </div> -->
                    <div class="k-source flexBox" ref="ksource" v-if="sourceList.length">
                        <picture class="picture" v-for="(img, index) in sourceList" @click="previewImg(img.src, index)">
                            <img class="img-loaded source-img" v-show="index < 4" :src="img.ThumbUrl">
                            <img class="img-loaded-detect" :src="img.ThumbUrl" v-show="false" @load="$placeImg">
                            <template v-if="sourceList.length > 4 && index === 3">
                                <div class="barrage" v-if="sourceList.length > 4 && index === 3"></div>
                                <div class="barrage-text">
                                    <span class="barrage-text-plus">+</span>{{ sourceList.length - 4 }}
                                </div>
                            </template> 
                        </picture>
                    </div>
                    
                    <div class="k-video" v-if="videoList.length">
                        <p class="video flexBox" @click="showVideo(video.src)" v-for="(video,index) in videoList">
                            <i class="video-play"></i>
                            <span v-text="video.FileName"></span>
                            <i class="video-download" @click.stop="downloadVideo(video)"></i>
                        </p>
                    </div>
                    <div class="k-attachment" v-if="attachmentList.length">
                        <div class="attachment flexBox" @click="openFile(attachment.src, attachment.FileType, attachment.FileName, attachment.Slug)" v-for="attachment in attachmentList">
                            <i class="attachment-link"></i>
                            <span v-text="attachment.FileName"></span>
                        </div>
                    </div>

                    <!-- 标签展示 -->
                    <div class="k-tag flexBox" v-if="knowledgeInfo.Tags && knowledgeInfo.Tags.length">
                        <p class="tag" v-for="tag in knowledgeInfo.Tags">
                            <span v-text="tag.title"></span>
                        </p>
                    </div>
                    <div class="k-view-count">
                        <span>{{ knowledgeInfo.TotalViewCount | validCount }}人浏览</span>
                    </div>
                </div>
            </div>

            <!-- 常见相关问题列表 -->
            <div class="knowledge-recommend padding-sets" v-show="FIList.length">
                <div class="recommend-tabs flexBox">
                    <span class="recommend-tab">相关常见问题</span>
                </div>
                <div class="recommend-lists recommend-interest-lists">
                    <section class="recommend-list" v-for="interest in FIList" v-text="interest.Title" @click="viewFaq(interest)"></section>
                </div>
                <div class="recommend-load" @click="loadMore()" v-if="FIPageIndex < FIPageCount && prevAjaxEnd">查看更多</div>
                <div></div>
                <loading-more v-if="callRelatedFaqLoading"></loading-more>
            </div>

            <!-- 评论列表区域 -->
            <div class='leave-divider'>
                <leave-list :commentListTitle='commentListTitle' :extraInfo="matchedComment" :commentsTotalCount="commentsTotalCount" :commentsForPageCount="commentsForPageCount" :commentsList="commentsList" :checkMoreComment='checkMoreComment' @checkMoreCommentClick="checkMoreCommentClick" @deleteComment="deleteComment" @initCommentList="initCommentList" @refreshCommentList="refreshCommentList"></leave-list>
            </div>


            <!-- 打开侧边知识目录按钮 -->
            <div class="knowledge-detail-btn" @click="goTreeMenu">
                <div class="knowledge-detail-title">
                    <i class="icon icon-construct-active"></i>
                    <span>知识目录</span>
                </div>
            </div>

            <!-- 侧边知识目录组件 -->
            <treeMenu2 v-if="isShowTree"></treeMenu2>

            <!-- 视频区域 -->
            <div class="video-wrapper" v-show="callVideoPlayer">
                <div class="video-mask" @click="hideVideo"></div>
                <video class="video-player" ref="videoPlayer" :src="videoUrl"></video>
            </div>
            <!-- <video-player :videoUrl="videoUrl" v-show="callVideoPlayer"></video-player> -->

            <!-- 水印组件 -->
            <water-mark ref="watermark"></water-mark>

            <!-- 图片 -->
            <photo-package class="content-img-preview" v-if="imgUrlList.length" :list="imgUrlList" :options="options" selector=".thumb-img" @on-close="closeHandler" ref="contentPreview"></photo-package>
            <photo-package v-if="sourceList.length" :list="sourceList" :options="options" selector=".source-img" @on-close="closeHandler" ref="sourcePreview"></photo-package>


            <!-- 路由变化时 评论退出提醒 -->
            <quit-message v-if='callQuitWarning' :messageTitle="messageTitle" :messageText="messageText" :queryBtn="queryBtn" @closeQuitWarning='closeQuitWarning' @eventContinue="eventContinue"></quit-message>

            <!-- 无权限页面 -->
            <unauthorize v-if="callUnauthorize" :unauthorizeType="unauthorizeType"></unauthorize>

            <!-- 互动问答--bar -->
            <releave-recover :knowledgeInfo="knowledgeInfo" :extraInfo="matchedComment"></releave-recover>
        </div>
    </div>
</template>

<script>
import loadingMore from '@/components/loadingMore'
import waterMark from '../components/waterMark'
import PhotoPackage from 'photoswipe-package'
import treeMenu2 from './treeMenu/treeMenu2.vue'
import unauthorize from './404/403.vue'
import { SEARCH, COMMON, COMMENTS } from '../api'
import commonMixin from '@/utils/commonMixin'
import leaveList from '@/components/leaveList'
import releaveRecover from '@/components/releaveRecover'
import quitMessage from '@/components/quitMessage'
import dsBridge from '../utils/dsbridge'
import { wxConfig } from '@/utils/wxConfig';
import { wxPreviewImg } from '@/utils/wxPreviewImg';
import { GetQueryStringFromURL } from '../utils/util';

export default {
    name: 'knowledgeDetail',
    mixins: [ commonMixin ],
    components: {
        waterMark, PhotoPackage, treeMenu2, unauthorize, leaveList, releaveRecover, loadingMore, quitMessage
    },
    data() {
        return {
            //埋点用LogId
            LogId: '',
            lastVideoUrl: '',
            videoButtonSwitch: true,
            ajaxDone: false,
            callUnauthorize: false,
            unauthorizeType: '401',
            lastScrollTop: 0,
            tooltipShow: false,

            resetClass: true,  // 重置样式的判断变量

            // 图片预览组件
            imgUrlList: [],
            options: {
                loop: false,
                zoomEl: true,
                fullscreenEl: false,
                tapToClose: true,
            },

            // 一系列参数，我也不知道哪些有用哪些没用
            recommendType: null,
            prevAjaxEnd: true,
            KIList: [],
            sourceList: [],
            sourceUrlList: [],  // 图片Url List 用于图片预览
            videoList: [],
            videoUrl: '',
            callVideoPlayer: false,
            attachmentList: [],
            KBInfoId: '',
            knowledgeInfo: {
                OwnerEngName: '',
                OwnerName: '',
                HeadPic: '/static/images/default.png',
                Tags: [],
                TotalViewCount: '-'  // 阅读人数
            },
            isThumbUp: false,//点赞
            isThumbDown: false,//踩

            //相关常见问题列表 的 变量
            FIPageIndex: 1,
            FIPageSize: 10,
            FIPageCount: 1,
            FIList: [],

            // 发送评论区域变量
            callQuitWarning: false,  //用于显示退出确认弹窗
            toRouterPath: '',     //用于保存想退出当前页面并前往的路由
            // 退出确认弹窗的内容以及按钮文字
            messageTitle: '是否继续退出',
            messageText: '未提交内容将不会被保存,是否继续退出?',
            queryBtn: '继续退出',

            // 互动问答区域变量
            commentsList: [],
            commentListTitle: '互动问答',
            commentsTotalCount: 0,//一共多少条评论(含子回复)
            commentsForPageCount: 0,//一共多少条主评论GetKnowledgeDetail
            leavePageIndex: 1,
            leavePageSize: 100,
            // 其它
            checkMoreComment: true,//是否显示查看更多  点击后直接调用滚动加载更多并隐藏查看更多
            leavePrevAjaxEnd: true,//加载更多是否完成
            callRelatedFaqLoading: false, // 是否显示相关常见问题loading
            matchedComment: {}  // 匹配到的那条评论
        }
    },
    computed: {
        isShowTree() {  // 是否显示结构目录
            return this.$store.getters.GET_showMenu
        },
        authType() {
            return localStorage.AUTH_TYPE
        },
        inputContent() {
            return this.$store.getters.GET_InputContent
        },
        callCommentInput() {
            return this.$store.getters.GET_CallCommentInput
        },
    },
    mounted() {
        this.initData(this.$route.params.uuid.split('&')[0]);
        wxConfig()
    },
    activated() {
        // 不管三七二十一，先加载一次水印再说(为了防止测试的这样一种骚操作：在打开图片预览的时候分享网页给别人，然后自己再打开这个分享，这个时候水印已经被打在图片预览组件里，页面是没有水印的，但是打开分享，图片预览组件是不会重新打开的，所以我重新渲染一次水印就OK了)

        setTimeout(() => {  // 彻底关闭之后重新绘画
            this.$refs.watermark && this.$refs.watermark.initWaterMark()
        }, 500)
        this.KBInfoId !== this.$route.params.uuid.split('&')[0] ? this.initData(this.$route.params.uuid.split('&')[0]) : this.$refs.scrollboxWrapper.scrollTop = this.lastScrollTop
    },
    methods: {
        callPhone(data) {  // 打电话
            if (this.authType === 'WECHAT') {
                window.location.href = "tel:" + data;
            } else if (this.authType === 'TOOLKIT') {
                if (dsBridge.call("toolkit.getTokenSyn")) {
                    let phone = "toolkit://dial?phone=" + data;
                    dsBridge.call("common.dialSyn", phone);
                }
            } else if(this.authType === 'APOLLO') {
                dsBridge.call("ApolloApp.invokeAsyn",
                    {
                        "methodName": "callMobile",
                        "params": {
                            "tel": data
                        }
                    }
                )
            }
        },
        openFile(src, htmlFileName, staticName, slug) {  // 打开文件

            let lastIndex = htmlFileName.lastIndexOf('.')  // 文件名最后一个点的索引
            let fileName = htmlFileName.substring(0, lastIndex)  // 带有html标签的文件名
            let fileType = htmlFileName.substring(lastIndex + 1)  // 文件类型
            let formatFileName = htmlFileName.replace(new RegExp(/<.+?>/, 'g'), '')  // 文件名

            if (/7z|rar|zip/i.test(fileType)) {
                this.$router.push({
                    path: '/sendMail',
                    query: {
                        fn: staticName,
                        slug: slug
                    }
                })
                return
            }

            if (this.authType === "APOLLO") {
                dsBridge.call('ApolloApp.invokeAsyn', {
                    methodName: "openFile",
                    params: {
                        "url": src,
                        "suffix": fileType,
                        "file_name": formatFileName
                    }
                }, function (res) {
                    console.log('error', res);
                })
                return
            }
            if (this.authType === 'TOOLKIT') {
                // docs: https://confluence.nevint.com/pages/viewpage.action?pageId=165983913
                dsBridge.call('NIOMateBridge.openFileByInstalledApp', {
                    "url": src
                },function (res) {
                    console.log('---', res)
                })
                return
            }

            // window.open(src)
            location.href = src
        },
        downloadVideo(video) {  // 发送目标视频到用户
            // 节流
            if(!this.videoButtonSwitch && video.src == this.lastVideoUrl) {
                // this.$store.commit('SetAndCallToast', '操作太频繁啦')
                return
            };
            this.lastVideoUrl = video.src
            this.videoButtonSwitch = false
            try {
                // adaccount、时间、点击的视频名字、所属的知识点名字
                COMMON.DOP_ViewData({
                    logName: 'NIOHOME_25_DownVedio',
                    data: {
                        ADAccount: localStorage.ADAccount,
                        VedioName: video.FileName,
                        KBName: this.knowledgeInfo.Title
                    }
                }).then((res)=>{
                    console.log(res)
                })
            }
            catch(error){
                console.log(error);
            }

            this.$store.commit('SetAndCallToast', '稍后附件会通过邮件发送 请查收')
            let slug = {slug:video.Slug}
            COMMON.SendMail(slug).then((res)=>{
                if(res.Code != 200) this.$store.commit('SetAndCallToast', res.Code + ',' + res.Msg)
            })
            setTimeout(() => {
                this.videoButtonSwitch = true
            }, 30000);
        },
        scrollHandler() {  // 滚动加载
            let scrollTop = this.$refs.scrollboxWrapper.scrollTop
            let visible_h = this.$refs.scrollboxWrapper.clientHeight
            let scrollBox_h = this.$refs.scrollBox ? this.$refs.scrollBox.clientHeight : 0
            if (scrollTop + visible_h >= scrollBox_h) {
                this.loadMoreLeave()
            }
        },
        previewImg(currUrl, index) {
            if (index === 3 && this.sourceList.length > 4) {
                // 存储vuex数据 避免进入页面后重新ajax请求
                this.$store.commit('setSourceList', this.sourceList)
                this.$router.push({ path: '/sourceView', query: { uuid: this.KBInfoId } })
                return
            }
            wxPreviewImg(currUrl, this.sourceUrlList)
        },
        initData(KBInfoId) {  // 初始化页面
            window.addEventListener("popstate", this.hideVideo, false)
            this.KBInfoId = KBInfoId
            this.$refs.scrollboxWrapper.scrollTop = 0
            this.FIPageIndex = 1
            this.ajaxDone = false
            this.callUnauthorize = false
            this.$store.commit('SET_CallCommentInput', false)
            // 获取详情
            this.initDetail()
            // 获取评论列表
            this.initCommentList()
        },
        initDetail() {  // 获取详情
            if (!localStorage.tooltipShow_1121) {
                // reset to false 再执行浮层动画
                this.tooltipShow = false
            }
            SEARCH.GetKnowledgeDetail({
                KBInfoId: this.KBInfoId,
                width: 89,
                height: 89
            }).then((res) => {
                this.ajaxDone = true;
                this.$refs.scrollboxWrapper.addEventListener('scroll', this.scrollHandler, false)
                if (res.Code == 401) {
                    this.unauthorizeType = '401'
                    this.callUnauthorize = true
                } else if (res.Code == 404) {
                    this.unauthorizeType = '404'
                    this.callUnauthorize = true
                } else if (res.Code == 200) {

                    this.knowledgeInfo = res.Data
                    this.$nextTick( () => {
                        // 重置Knowledge正文内容字体&字号样式
                        this.resetFontStyle('kMaintain')

                        // 只有在第一次查看问题/知识点详情时，才展示tooltip
                        if (!localStorage.tooltipShow_1121) {
                            this.tooltipShow = true
                        }
                    })

                    this.KBInfoId = res.Data.KBInfoId

                    this.getLogId()
                    this.initInterestData()
                    this.initSource(res.Data)
                }
            }).catch((error) => {
                this.ajaxDone = true;
            })
        },
        resetFontStyle(ref) {  // 重置正文的字体字号样式

            // 需要被重置样式的DOM节点
            let nodes = this.$refs[ref].childNodes

            for (let i = 0; i < Array.from(nodes).length; i++) {
                this.deepLoop(nodes[i])
            }

            // using class `k-maintain-font-reset` to overwrite unset property
            this.resetClass = true
        },
        deepLoop(nodes) {
            if (nodes.nodeType === 1) {
                // console.log(nodes, nodes.childNodes)
                // reset `font` property to `unset`
                nodes.style.fontSize = 'unset'
                nodes.style.fontFamily = 'unset'
                if (nodes.childNodes.length > 0) {
                    for (let j = 0; j < nodes.childNodes.length; j++) {
                        this.deepLoop(nodes.childNodes[j])
                    }
                }
            }
        },
        setTooltipRead() {  // 关闭tooltip 并设置为已读
            this.tooltipShow = false
            // set tooltip showing flag to local
            localStorage.tooltipShow_1121 = 'viewed'
        },
        initSource(sourceData) {
            let fileList = sourceData && sourceData.FileList && sourceData.FileList.map((file) => {
                return {
                    // transfer key named `FileUrl` to `src`
                    src: file.FileUrl,
                    ThumbUrl: file.ThumbUrl,
                    FileName: file.FileName,
                    FileType: file.FileType,
                    Slug: file.Slug
                }
            })
            this.sourceList = fileList ? fileList.filter((file) => {
                return /jpg|jpeg|png/i.test(file.FileType)
            }) : []

            this.sourceUrlList = this.sourceList.map( (item) => {
                return item.src
            })

            // this.sourceUrlList = []
            // this.sourceList.forEach((ele) => {
            //     this.sourceUrlList.push(ele.FileUrl)
            // })
            this.videoList = fileList ? fileList.filter((file) => {
                return /mp4/i.test(file.FileType)
            }) : []
            this.attachmentList = fileList ? fileList.filter((file) => {
                return /doc|docx|ppt|pptx|xls|xlsx|pdf|7z|rar|zip/i.test(file.FileType)
            }) : []

            this.$nextTick(() => {
                let oImgList = this.$refs.kMaintain.querySelectorAll('img')
                this.imgUrlList = []
                Array.from(oImgList).forEach((imgEl, index) => {
                    this.imgUrlList.push({
                        src: imgEl.getAttribute('src')
                    })
                    imgEl.setAttribute('onerror', 'this.onerror=null;this.src="../../static/images/before_load.png"')

                    let oEle = document.createElement('div')
                    imgEl.className = 'thumb-img longtap-disable'
                    let oDiv = imgEl.parentNode.insertBefore(oEle, imgEl)
                    oDiv.className = 'thumb-img-wrap'
                    oDiv.appendChild(imgEl)
                    oDiv.addEventListener('click', () => {
                        // 图片预览组件的水印
                        this.$refs.watermark && this.$refs.watermark.initWaterMark(true)
                        this.$refs.contentPreview.show(index)
                    }, false)
                })

                // 生成详情页的水印
                setTimeout(() => {  // 彻底关闭之后重新绘画
                    this.$refs.watermark && this.$refs.watermark.initWaterMark()
                }, 300)
            })
        },
        initInterestData() {
            // 获取相关问题
            COMMON.GetFaqInterestsByKID({
                KBInfoId: this.KBInfoId,
                PageIndex: this.FIPageIndex,
                PageSize: this.FIPageSize
            }).then((res) => {
                if (res.Data != null && res.Data.List != null) {
                    this.FIList = res.Data.List
                    this.FIPageCount = Math.ceil(res.Data.TotalCount / this.FIPageSize)
                    if (this.recommendType === null && res.Data && res.Data.List.length) {
                        this.recommendType = 'interest'
                    }
                } else {
                    this.FIList = []
                }
                setTimeout(() => {  // 彻底关闭之后重新绘画
                    this.$refs.watermark && this.$refs.watermark.initWaterMark()
                }, 300)
            })

        },
        loadMore() {
            if (!this.prevAjaxEnd) return
            if (this.FIPageIndex >= this.FIPageCount) return
            this.prevAjaxEnd = false
            this.callRelatedFaqLoading = true
            this.$store.commit('SET_LOADING_POSITION', 'bottom')
            if (this.recommendType === 'interest') {
                COMMON.GetFaqInterestsByKID({
                    KBInfoId: this.KBInfoId,
                    PageIndex: ++this.FIPageIndex,
                    PageSize: this.FIPageSize
                }).then((res) => {
                    if (res.Data && res.Data.List) {
                        this.FIList = this.FIList.concat(res.Data.List)
                        this.prevAjaxEnd = true
                        this.callRelatedFaqLoading = false
                        this.$store.commit('SET_LOADING_POSITION', 'middle')
                    }
                }).catch(() => {
                    this.prevAjaxEnd = true
                    this.callRelatedFaqLoading = false
                    this.$store.commit('SET_LOADING_POSITION', 'middle')
                })
            } else {
                this.prevAjaxEnd = true
                this.callRelatedFaqLoading = false
                this.$store.commit('SET_LOADING_POSITION', 'middle')
            }
        },

        // 评论区方法
        //初始化评论列表
        initCommentList() {
            this.leavePageIndex = 1
            this.commentsTotalCount = 0
            this.commentsList = []
            COMMENTS.GetCommentList({
                "KBInfoId": this.KBInfoId,
                "PageIndex": this.leavePageIndex,
                "PageSize": this.leavePageSize,
            }).then((res) => {
                if (res && res.Data && res.Data.List && res.Data.List.length > 0) {
                    this.commentsList = res.Data.List;
                    // 用于显示在页面上的总评论数(主评论数+子评论数)
                    this.commentsTotalCount = res.Data.TotalCount;
                    // 用于分页的评论总数(主评论数)
                    this.commentsForPageCount = res.Data.ForPageCount;
                    // 当  总页数小于等于1时 【查看更多评论按钮】  消失
                    this.checkMoreComment = !(Math.ceil(this.commentsForPageCount / this.leavePageSize) <= 1)

                    // 匹配commentsList中Id一样的那条评论
                    let tempArr = this.commentsList.filter( (list) => {
                        // return list.Id === this.$route.params.subCommentId
                        return list.Id === this.$route.params.commentId
                    }) || []
                    this.matchedComment = tempArr[0]

                    setTimeout(() => {  // 彻底关闭之后重新绘画
                        this.$refs.watermark && this.$refs.watermark.initWaterMark()
                    }, 300)
                }
            }).catch((error) => {
                console.log(error);
            })
        },
        // 点击查看更多按钮加载第二页评论
        checkMoreCommentClick() {
            this.checkMoreComment = false
            this.loadMoreLeave()
        },
        //滚动加载更多评论
        loadMoreLeave() {
            // 当  查看更多按钮在的时候   禁止滚动加载
            if (this.checkMoreComment) return
            // 当  查看更多按钮消失后，  当 当前页数 大于等于  总页数时，  禁止滚动加载
            if (this.leavePageIndex >= Math.ceil(this.commentsForPageCount / this.leavePageSize)) return
            // 当上一次滚动加载未完成时，禁止滚动加载
            if (!this.leavePrevAjaxEnd) return

            this.leavePrevAjaxEnd = false;
            this.$store.commit('SET_LOADING_POSITION', 'bottom')
            COMMENTS.GetCommentList({
                "KBInfoId": this.KBInfoId,
                "PageIndex": ++this.leavePageIndex,
                "PageSize": this.leavePageSize,
            }).then((res) => {
                this.$store.commit('SET_LOADING_POSITION', 'middle')
                if (res && res.Data && res.Data.List && res.Data.List.length > 0) {
                    this.commentsList = this.commentsList.concat(res.Data.List);
                    this.commentsTotalCount = res.Data.TotalCount;
                    this.commentsForPageCount = res.Data.ForPageCount;
                    setTimeout(() => {  // 彻底关闭之后重新绘画
                        this.$refs.watermark && this.$refs.watermark.initWaterMark()
                    }, 300)
                }
                this.leavePrevAjaxEnd = true
            }).catch((error) => {
                this.leavePrevAjaxEnd = true;
                this.$store.commit('SET_LOADING_POSITION', 'middle')
            })
        },
        //新增评论到列表中，更新评论列表
        refreshCommentList(replyerInfo, commentInfo, commentIndex) {
            // 更新 评论数组 ,
            if (!commentInfo) {
                // 在数组第一条添加新评论
                this.commentsList.unshift(replyerInfo)

                // 更新评论总数
                this.commentsTotalCount += 1
                this.commentsForPageCount += 1

                console.log('commentInfo', commentInfo)
                // 添加了新评论，分页排序错位，如果评论总数大于等于十条（分页条数）则将最后一条评论删除，在加载下一页的时候会加载到这条删除的而不会出现重复。
                if (this.commentsForPageCount >= this.pageSize) this.commentsList.pop()
            } else {
                console.log('commentIndex', commentIndex)
                // 将新回复添加到子评论列表中，不用删除最后一条，因为该页面的回复 没有分页
                this.commentsList[commentIndex].ReplyList ? this.commentsList[commentIndex].ReplyList.push(replyerInfo) : this.commentsList[commentIndex].ReplyList = [replyerInfo]
                this.commentsTotalCount += 1;
            }
            //发布成功  关闭清空输入框等
            setTimeout(() => {  // 彻底关闭之后重新绘画
                this.$refs.watermark && this.$refs.watermark.initWaterMark()
            }, 300)
            this.$store.commit('SET_CallCommentInput', false)
            this.$store.commit('SET_InputPlaceholder', '写下我的留言或提问...')
        },

        //删除评论
        deleteComment(deleteIndex) {
            // 将对应评论的  IsDel 属性设置为true 即可删除
            this.commentsList[deleteIndex].IsDel = true
            this.commentsTotalCount--
            this.commentsForPageCount--
        },

        // 确认退出弹框 cancle按钮
        closeQuitWarning() {
            this.callQuitWarning = false
        },
        // 确认退出弹框 continue按钮
        eventContinue() {
            // 关闭输入框，清除掉 inputContent ，所以继续操作的时候不会阻止路由跳转了
            this.$store.commit('SET_InputContent', false)
            this.$store.commit('SET_CallCommentInput', false)
            // 关闭确认框
            this.callQuitWarning = false
            // 跳转路由
            setTimeout(() => {
                this.$router.push(this.toRouterPath)
            }, 300)
        },
        closeHandler() {  // 关闭图片查看器
            setTimeout(() => {  // 彻底关闭之后重新绘画
                this.$refs.watermark && this.$refs.watermark.initWaterMark()
            }, 300)
        },
        showImg(index) {  // 附件图片预览
            if (index === 3 && this.sourceList.length > 4) {
                this.$store.commit('setSourceList', this.sourceList)
                this.$router.push({ path: '/sourceView', query: { uuid: this.KBInfoId } })
                return
            }
            // 图片预览组件的水印
            // this.$refs.watermark && this.$refs.watermark.initWaterMark(true)
            // this.$refs.sourcePreview.show(index)
        },
        showVideo(src) {    //  打开视频播放器
            this.videoUrl = src;
            // this.videoUrl = "https://box-filestorage-uat.niohome.com/api/objects/download?slug=NjA5MTAyNjMyNA==&token=5c6a5774e1f8d356161067jwku";
            // this.videoUrl = "https://source.niohome.com/MyNextEv/Value/Video/5分钟读懂真诚.mp4";
            this.callVideoPlayer = true;
            document.querySelector("#app").style.overflow = "hidden";
            setTimeout(() => {
                this.$refs.videoPlayer.play();
            }, 200);
        },
        hideVideo() {
            this.callVideoPlayer = false;
            document.querySelector("#app").style.overflow = "";
        },
        //点赞
        thumbUp() {
            this.isThumbUp = !this.isThumbUp;
        },
        //踩
        thumbDown() {
            this.isThumbDown = !this.isThumbDown;
        },
        //显示知识目录
        goTreeMenu() {
            try {
                MtaH5.clickStat('menu10001')
                console.log('统计成功');
            } catch (error) {
                console.log('统计失败');
            }
            this.$store.state.menu.KBInfoId = this.KBInfoId;
            this.$store.state.menu.showMenu = true;
            document.querySelector("#app").style.overflow = "hidden";
        },
        //查看相关常见问题(faq)
        viewFaq(faq) {
            // this.$store.commit('SET_KI_CACHE', {
            //     uuid: this.$route.params.uuid.split('&')[0],
            //     activeTab: this.recommendType,
            //     detail: this.knowledgeInfo,
            //     KIList: this.KIList,
            //     FIList: this.FIList
            // })

            //--------埋点-------
            try{
                let data = {
                    LogId:this.LogId,
                    FAQId:faq.KBInfoId,
                    FAQName:faq.Title
                }
                COMMON.UpdateKBDetailViewData(data).then(()=>{
                    this.$router.push({name: 'faq', params: {uuid: faq.KBInfoId}})
                })
            }
            catch (e) {
                console.log(e);
                this.$router.push({name: 'faq', params: {uuid: faq.KBInfoId}})
            }
            //-------------------

        },
        // 在退出路由的时候需要进行的一些骚操作，反正有用
        resetPage() {
            this.$store.commit('SET_CallCommentInput', false)
            this.callQuitWarning = false
            this.hideVideo()
            this.$store.state.menu.showMenu = false
            window.removeEventListener('popstate', this.hideVideo, false)
            this.callUnauthorize = false
            this.$refs.scrollboxWrapper.removeEventListener('scroll', this.scrollHandler)
        },

        //获取logid  埋点方法
        getLogId(){
            try{
                let data = {
                    KBInfoId:this.KBInfoId,
                    KBName:this.knowledgeInfo.Title
                }
                COMMON.AddKBDetailViewData(data).then((res)=>{
                    this.LogId = res.Data.LogId
                })
            }
            catch (e) {
                console.log(e);
            }
        }

    },
    watch:{
        '$route' (to, from) {
            if(from.name !== 'message') return
            //如果是从消息列表页过来，得更新评论
            this.initCommentList()
        }
    },
    //仅路由参数变化（从一个知识点跳转到另一个知识点）
    beforeRouteUpdate(to, from, next) {
        //先判断是否有输入过评论内容或上传过图片)
        if (this.inputContent) {
            //如果有内容则不退出路由并弹出退出评论确认框
            this.callQuitWarning = true
            this.toRouterPath = to.fullPath
            next(false)
        } else {
            this.initData(to.params.uuid)
            next()
        }
    },
    // 路由名变化（从知识点返回到上一级非知识点路由）
    beforeRouteLeave(to, from, next) {
        this.lastScrollTop = this.$refs.scrollboxWrapper.scrollTop
        //先判断是否有输入过评论内容或上传过图片)
        if (this.inputContent) {
            //如果有内容则不退出路由并弹出退出评论确认框
            this.callQuitWarning = true
            this.toRouterPath = to.path
            next(false)
        } else {
            this.resetPage()
            next()
        }
    }
}
</script>

<style lang="scss" type="text/scss" scoped>

    .knowledge-detail-box {
        position: relative;
        height: 100%;
        overflow: scroll;

        .knowledge-detail-wrapper {
            padding-bottom: j(300);
            position: relative;
        }

    }
    .box-overflow-hidden{
        overflow: hidden;
    }
    .grayColor {
        color: #9B9DA9 !important;
    }

    .warnIcon {
        width: j(30);
        height: j(30);
        display: block;
    }

    .warn_svg {
        width: j(35);
        height: j(35);
    }

    .warn_title {
        margin-left: j(10);
    }

    .arrow-right {
        width: j(20);
        height: j(20);
        display: block;
        border-top: 1px solid;
        border-right: 1px solid;
        box-sizing: border-box;
        transform: translateX(j(-6)) rotate(45deg);
    }

    .knowledge-head {
        position: relative;
        padding: j(40) 0 j(30);
        font-size: 0;
        width: j(650);
        margin: 0 auto;
        border-bottom: 1px solid #f0f1f2;

        .k-type {
            width: 100%;
            font-size: j(24);
            font-weight: bold;
            color: #9b9da9;
        }

        .k-title {
            margin-top: j(10);
            font-size: j(38);
            font-weight: 700;
            color: #363c54;
            word-break: break-word;
            width: 100%;
        }

    }

    .knowledge-content {
        margin-top: j(25);
        padding-bottom: j(40);
        font-size: j(32);
        color: #363c54;

        .k-author {

            .avator {
                margin-right: j(20);
                width: j(80);
                height: j(80);
                border-radius: 50%;
            }

            .flexItem {
                font-size: 0;
            }

            .k-author-name {
                font-size: j(32);
                font-weight: 700;
            }

            .k-update-last {
                margin-bottom: j(5);
                display: inline-block;
                font-size: j(24);
                color: #9b9da9;
            }

            .tel {
                width: j(60);
                height: j(60);
                display: block;
            }

            .k-enterprise-wechat {
                position: relative;
                margin-left: j(20);
                font-size: 0;
            }

            .tooltip-wrap {
                position: absolute;
                bottom: j(30 + 60); right: j(-24);
                .tooltip {
                    display: block;
                    width: j(480);
                    padding: j(18) 0;
                    font-size: j(28);
                    color: #fff;
                    background: #00bebe;
                    text-align: center;
                    border-radius: j(48);
                }
                .k-close {
                    font-style: normal;
                    margin-left: j(20);
                }
                .bottom-trangle {
                    position: absolute;
                    right: j(39);
                    top: 100%;
                    border-top: j(15) solid #00bebe;
                    border-left: j(15) solid transparent;
                    border-right: j(15) solid transparent;
                    width: 0; height: 0;
                }
            }
            .opacity-fade-enter {
                opacity: 0;
                transform: translateY(j(30));
            }
            .opacity-fade-enter-active {
                transition: all .5s ease 1s;
            }
        }

        .k-maintain {
            font-weight: 400;
            margin-top: j(30);
            margin-bottom: j(60);
            word-break: break-word;
        }

        .k-source {
            // position: relative;
            font-size: 0;
            height: j(155);
            justify-content: flex-start;
            overflow: hidden;
            margin-bottom: j(50);

            .picture {
                position: relative;
                background-image: url(../../static/images/before_load.png);
                background-repeat: no-repeat;
                background-size: contain;
                img{
                    pointer-events: none;
                }
            }
            img {
                width: j(155);
                height: j(155);
                border-radius: 2px;
            }
            .picture + .picture {
                margin-left: j(10);
            }

            .img-loaded {
                opacity: 0;
                transition: all .3s linear;
                object-fit: cover;
            }

            .barrage {
                position: absolute;
                top: 0; bottom: 0;
                left: 0; right: 0;
                background: #363c54;
                opacity: .6;
                border-radius: 2px;
            }
            .barrage-text {
                position: absolute;
                top: 50%; left: 50%;
                font-size: j(46);
                color: #fff;
                transform: translate(-50%, -50%);
            }
            .barrage-text-plus {
                position: relative;
                top: j(-5);
            }
        }

        .k-attachment, .k-video {
            margin-bottom: j(30);

            i:before {
                color: #00bcbc;
            }

            span {
                color: #00bcbc;
            }

            .attachment, p.video {

                &:active i:before {
                    color: #009292;
                }

                &:active span {
                    color: #009292;
                }

            }

            .attachment + .attachment, .video + .video {
                margin-top: j(30);
            }

            .attachment {

                .attachment-link {
                    display: block;
                    height: j(36);
                    width: j(36);
                    margin-right: j(10);
                    background: url('/static/images/attachment_link.png') no-repeat;
                    background-size: cover;
                }

            }

            p.video {
                display: flex;
                span{
                    flex: 1;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .video-play {
                    height: j(36);
                    width: j(36);
                    margin-right: j(10);
                    background: url('../../static/images/video_play.png') no-repeat;
                    background-size: cover;
                }
                .video-download{
                    height: j(48);
                    width: j(48);
                    margin-left: j(50);
                    background: url('/static/images/icon/save_icon.png') no-repeat;
                    background-size: cover;
                }
            }

        }

        .k-thumbs {
            width: 100%;
            margin: j(50) auto;
            display: flex;
            justify-content: center;

            .k-thumbs-circle {
                width: j(120);
                height: j(120);
                border: 1px solid #D8D8D8;
                border-radius: j(60);
                margin: 0 j(30);
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                img {
                    width: j(44);
                    height: j(44);
                    display: block;
                }

                span {
                    font-size: j(26);
                    color: #9B9DA9;
                    text-align: center;
                    margin-top: j(4);
                }

                .thumbup_svg {
                    width: j(50);
                    height: j(40);
                }

            }

            .isThumbUp, .isThumbDown {
                border: 1px solid #B7E8EA;

                .isThumbTitle {
                    color: #00bcbc;
                }

            }


        }

        .k-tag {
            flex-wrap: wrap;
            padding-top: j(20);
            position: relative;

            &:after {
                @include thin-bt(#f1f2f3);
            }

            .tag {
                padding: j(10) j(30);
                margin-top: j(20);
                margin-right: j(20);
                font-size: j(28);
                color: #989da9;
                background-color: #f7f7f8;
                border-radius: j(30);
            }

        }
        .k-view-count {
            margin-top: j(50);
            font-size: j(24);
            color: #9b9da9;
        }
    }

    .knowledge-recommend {
        border-top: j(20) solid #f7f7f8;
        font-size: j(30);
        color: #363c54;

        .recommend-tabs {
            position: relative;
            height: j(110);
            line-height: j(110);
            font-size: j(28);

            &:after {
                @include thin-bb(#f1f2f3);
            }

            .recommend-tab {
                height: 100%;
                color: #9b9da9;
                box-sizing: border-box;
                transition: color .3s linear;
            }

        }

        .recommend-lists {

            section {
                margin-top: j(40);

                &:last-child {
                    margin-bottom: j(40);
                }
            }
        }

        .recommend-load {
            background-color: #F0FCFC;
            height: j(60);
            width: j(182);
            margin: j(80) auto;
            font-size: j(28);
            color: #00bebe;
            border-radius: j(28);
            display: flex;
            align-items: center;
            justify-content: center;
        }

    }

    .knowledge-detail-btn {
        width: j(280);
        height: j(180);
        line-height: j(180);
        z-index: 9;
        position: fixed;
        left: 0;
        bottom: j(120);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .knowledge-detail-title {
            width: j(244);
            height: j(150);
            z-index: 1;
            top: 0;
            left: 0;
            background-image: url('/static/images/tree-menu-button.png');
            background-size: 100%;
            background-repeat: no-repeat;
            background-position: left center;
            display: flex;
            align-items: center;
            i {
                margin-left: j(35);
                font-size: j(30);
                color: #00BCBC;
            }

            span {
                color: #00BCBC;
                font-size: j(28);
                line-height:j(32);
                margin-left: j(10);
            }

        }

        img {
            width: 100%;
            display: inline-block;
            margin-top: j(18);
        }

    }


    .padding-sets {
        padding-left: j(50);
        padding-right: j(50);
    }


    .video-wrapper {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;

        .video-mask {
            position: absolute;
            height: 100%;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.8);
        }

    }

    .video-player {
        position: relative;
        z-index: 10;
        width: j(750);
        height: j(421.875);
    }


    .leave-divider {
        border-top: j(20) solid #F7F7F8;
    }

</style>
<style lang="scss" type="text/scss" module>
    .k-maintain {
        overflow-x: hidden;
        width: 100%;
        p + p {
            margin-top: j(20);
        }

        p > br {
            display: none;
        }

        video {
            display: block;
            width: 100% !important;
            height: auto !important;
            background-color: #000 !important;
        }
        img {
            pointer-events: none;
        }
        table{
            width: 100% !important;
        }
        ul{
            width: 100% !important;
            // list-style-type: decimal!important;
            li{
                list-style: disc !important;
                list-style-position: inside!important;
            }
        }
        ol{
            width: 100% !important;
            li{
                list-style: decimal!important;
                list-style-position: inside!important;
            }
        }
    }

    .k-maintain-font-reset {
        // important 覆盖行内样式 unset
        font-size: j(30)!important;
    }

    .k-title font {
        color: #363c54 !important;
    }
</style>
<style lang="scss" type="text/scss">
    .thumb-img-wrap {
        margin: j(50) 0;
        background-color: #fcfcfc;

        .thumb-img {
            display: block;
            width: 100% !important;

            &.longtap-disable {
                pointer-events: none;
            }

        }
    }
    .content-img-preview{
        .pswp__img{
            pointer-events: none;
        }
    }
    #mmmmmmmmmm {
        color: #00bebe;
    }
</style>



// WEBPACK FOOTER //
// src/views/knowledgeDetail.vue